'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp2;

var _Link = require('components/Link/Link');

var _Link2 = _interopRequireDefault(_Link);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _MobileMenu = require('./MobileMenu.scss');

var _MobileMenu2 = _interopRequireDefault(_MobileMenu);

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _session = require('redux/modules/session');

var _reactRouterRedux = require('react-router-redux');

var _media = require('utils/media');

var _helpers = require('utils/helpers');

var _lockscreen = require('redux/modules/lockscreen');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  MobileMenu: {
    displayName: 'MobileMenu'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Nav/MobileMenu.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var MobileMenu = _wrapComponent('MobileMenu')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.session.user,
    isLoggedIn: state.session.isLoggedIn,
    isOpenMobileNav: state.session.openMobileNav,
    locale: state.language.locale
  };
}, { logout: _session.logout, openLogin: _session.openLogin, openSignup: _session.openSignup, openMobileNav: _session.openMobileNav, pushState: _reactRouterRedux.routerActions.push, removeId: _lockscreen.removeId, setLoginSignupCallback: _session.setLoginSignupCallback }), _dec2 = (0, _reactCssModules2.default)(_MobileMenu2.default), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(MobileMenu, _Component);

  function MobileMenu() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MobileMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MobileMenu.__proto__ || (0, _getPrototypeOf2.default)(MobileMenu)).call.apply(_ref, [this].concat(args))), _this), _this.onOpenLogin = function () {
      _this.onCloseMobileNav();
      _this.props.setLoginSignupCallback(null);
      _this.props.openLogin(true);
    }, _this.onOpenSignup = function () {
      _this.onCloseMobileNav();
      _this.props.setLoginSignupCallback(null);
      _this.props.openSignup(true);
    }, _this.onCloseMobileNav = function () {
      _this.props.openMobileNav(false);
      _this.props.removeId('mobile-nav');
    }, _this.innerClick = function (event) {
      event.stopPropagation();
    }, _this.logout = function () {
      _this.onCloseMobileNav();
      window.location.href = '/logout';
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MobileMenu, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          isOpenMobileNav = _props.isOpenMobileNav,
          isLoggedIn = _props.isLoggedIn,
          locale = _props.locale;

      return _react3.default.createElement(
        'div',
        { className: 'mobile-menu', styleName: isOpenMobileNav ? 'container-show' : 'container-hide' },
        _react3.default.createElement(
          'div',
          { styleName: isOpenMobileNav ? 'mobile-bg-active' : 'mobile-bg', onClick: this.onCloseMobileNav },
          user && isLoggedIn ? _react3.default.createElement(
            'ul',
            { styleName: isOpenMobileNav ? 'mobile-nav-active' : 'mobile-nav', onClick: this.innerClick },
            _react3.default.createElement(
              'li',
              { styleName: 'mobile-profile' },
              _react3.default.createElement(
                _Link2.default,
                { to: '/dashboard/profile', onClick: this.onCloseMobileNav },
                _react3.default.createElement('span', { styleName: 'mobile-profile-pic', style: user.avatar_image && (0, _media.path)(user.avatar_image, 'profileAvatar', true) || null }),
                _react3.default.createElement(
                  'span',
                  { styleName: 'mobile-profile-name' },
                  user.name.first
                )
              )
            ),
            _react3.default.createElement(
              'li',
              null,
              _react3.default.createElement(
                _Link2.default,
                { styleName: 'mobile-dashboard-link', to: '/dashboard', onClick: this.onCloseMobileNav },
                _react3.default.createElement('i', null),
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'nav.list_menu.dashboard' })
              )
            ),
            _react3.default.createElement(
              'li',
              null,
              _react3.default.createElement(
                _Link2.default,
                { styleName: 'mobile-wishlist-link', to: '/dashboard?section=wishlist', onClick: this.onCloseMobileNav },
                _react3.default.createElement('i', null),
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'nav.list_menu.wishlist' })
              )
            ),
            _react3.default.createElement(
              'li',
              null,
              _react3.default.createElement(
                _Link2.default,
                { styleName: 'mobile-safety-link', onClick: this.onCloseMobileNav, to: '/trust-and-safety' },
                _react3.default.createElement('i', null),
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'nav.list_menu.trust_n_safety' })
              )
            ),
            _react3.default.createElement(
              'li',
              null,
              _react3.default.createElement(
                _Link2.default,
                { styleName: 'mobile-booking-link', to: '/dashboard/booking', onClick: this.onCloseMobileNav },
                _react3.default.createElement('i', null),
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'nav.list_menu.your_bookings' }),
                user.unread_notifications > 0 && _react3.default.createElement(
                  'div',
                  { styleName: 'unread' },
                  user.unread_notifications
                )
              )
            ),
            _react3.default.createElement(
              'li',
              null,
              _react3.default.createElement(
                _Link2.default,
                { styleName: 'mobile-service-link', onClick: this.onCloseMobileNav, to: '/dashboard/service' },
                _react3.default.createElement('i', null),
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'nav.list_menu.service' })
              )
            ),
            user.is_local_expert && _react3.default.createElement(
              'li',
              null,
              _react3.default.createElement(
                _Link2.default,
                { styleName: 'mobile-availability-link', to: '/dashboard/availability', onClick: this.onCloseMobileNav },
                _react3.default.createElement('i', null),
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'nav.list_menu.availability' })
              )
            ),
            _react3.default.createElement(
              'li',
              null,
              _react3.default.createElement(
                _Link2.default,
                { to: '/dashboard/referral', styleName: 'mobile-referral-link', onClick: this.onCloseMobileNav },
                _react3.default.createElement('i', null),
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'nav.list_menu.referral' })
              )
            ),
            locale !== 'zh' && _react3.default.createElement(
              'li',
              null,
              _react3.default.createElement(
                'a',
                { styleName: 'mobile-how-link', onClick: this.onCloseMobileNav, target: '_blank', href: 'https://www.takemetour.com/help-center', rel: 'noopener noreferrer' },
                _react3.default.createElement('i', null),
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'nav.list_menu.helpcenter' })
              )
            ),
            locale !== 'zh' && _react3.default.createElement(
              'li',
              null,
              _react3.default.createElement(
                _Link2.default,
                { styleName: 'mobile-list-trip-link', to: user.is_local_expert ? '/dashboard/listing' : '/local-expert-benefits', onClick: this.onCloseMobileNav },
                _react3.default.createElement('i', null),
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: user.is_local_expert ? 'nav.list_menu.your_listings' : 'nav.list_menu.list_your_trip' })
              )
            ),
            _react3.default.createElement(
              'li',
              null,
              _react3.default.createElement(
                _Link2.default,
                { styleName: 'mobile-verification-link', to: '/dashboard/verification', onClick: this.onCloseMobileNav },
                _react3.default.createElement('i', null),
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'nav.list_menu.verification' })
              )
            ),
            user.is_local_expert && _react3.default.createElement(
              'li',
              null,
              _react3.default.createElement(
                _Link2.default,
                { styleName: 'mobile-wallet-link', to: '/dashboard/wallet', onClick: this.onCloseMobileNav },
                _react3.default.createElement('i', null),
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'nav.list_menu.wallet' }),
                user.approved_earnings > 0 && _react3.default.createElement(
                  'span',
                  { styleName: 'wallet-noti' },
                  Math.floor(user.approved_earnings),
                  '\u0E3F'
                )
              )
            ),
            _react3.default.createElement(
              'li',
              null,
              _react3.default.createElement(
                'a',
                { styleName: 'mobile-signup-link', onClick: this.logout },
                _react3.default.createElement('i', null),
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'nav.list_menu.log_out' })
              )
            )
          ) : _react3.default.createElement(
            'ul',
            { styleName: isOpenMobileNav ? 'mobile-nav-no-user-active' : 'mobile-nav', onClick: this.innerClick },
            _react3.default.createElement(
              'li',
              null,
              _react3.default.createElement(
                _Link2.default,
                { styleName: 'mobile-safety-link', onClick: this.onCloseMobileNav, to: '/trust-and-safety' },
                _react3.default.createElement('i', null),
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'nav.list_menu.trust_n_safety' })
              )
            ),
            !(0, _helpers.isDusitApp)() && _react3.default.createElement(
              'li',
              null,
              _react3.default.createElement(
                'a',
                { styleName: 'mobile-signup-link', onClick: this.onOpenSignup },
                _react3.default.createElement('i', null),
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'nav.list_menu.signup' })
              )
            ),
            !(0, _helpers.isDusitApp)() && _react3.default.createElement(
              'li',
              null,
              _react3.default.createElement(
                'a',
                { className: 'mobile-menu-login', styleName: 'mobile-login-link', onClick: this.onOpenLogin },
                _react3.default.createElement('i', null),
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'nav.list_menu.login' })
              )
            ),
            locale !== 'zh' && _react3.default.createElement(
              'li',
              null,
              _react3.default.createElement(
                'a',
                { styleName: 'mobile-how-link', onClick: this.onCloseMobileNav, target: '_blank', href: 'https://www.takemetour.com/help-center', rel: 'noopener noreferrer' },
                _react3.default.createElement('i', null),
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'nav.list_menu.helpcenter' })
              )
            ),
            locale !== 'zh' && _react3.default.createElement(
              'li',
              null,
              _react3.default.createElement(
                _Link2.default,
                { styleName: 'mobile-list-trip-link', to: '/local-expert-benefits', onClick: this.onCloseMobileNav },
                _react3.default.createElement('i', null),
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'nav.list_menu.list_your_trip' })
              )
            )
          )
        )
      );
    }
  }]);
  return MobileMenu;
}(_react2.Component), _class2.propTypes = {
  user: _react2.PropTypes.object,
  isLoggedIn: _react2.PropTypes.bool,
  logout: _react2.PropTypes.func.isRequired,
  openLogin: _react2.PropTypes.func,
  openSignup: _react2.PropTypes.func,
  openMobileNav: _react2.PropTypes.func,
  isOpenMobileNav: _react2.PropTypes.bool,
  removeId: _react2.PropTypes.func,
  setLoginSignupCallback: _react2.PropTypes.func,
  locale: _react2.PropTypes.string
}, _temp2)) || _class) || _class));

exports.default = MobileMenu;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Nav/MobileMenu.js
// module id = 1569
// module chunks = 47